<modal class="h-modal" id="pendingwithdrawal">
  <div class="h-modal__rightside h-modal__mobile--fixed slideInRight">

    <!-- <h2 class="h-modal--title h-modal--mobtitle">{{'cashier.cancelpendingwithdrawal' | translate}}</h2> -->
    <div class="h-modal__header">
      <div class="h-modal__header--inner flex_spacebetween">
        <div class="h-modal--title">
          <span>{{'cashier.cancelpendingwithdrawal' | translate}}</span>
        </div>
        <div class="h-modal--close">
          <!-- <span class="close-mark" (click)="close()"></span> -->
          <i class="icon-cancel-1" (click)="close()"></i>
        </div>
      </div>
    </div>
    <div class="h-modal__scroll h-modal__without_footer pending_withdraw__body--outer" >
      <!-- Withdraw Success message content -->
      <div class="h-modal__success clearfix" *ngIf="showWithdrawSuccessMsg && !cancelledPendingWithdrawAmount">
        <div class="h-modal__success--left-blk">
          <span class="h-modal__success--icon icon-checkbox"></span>
        </div>
        <div class="h-modal__success--right-blk">
            <h5 class="h-modal__success--title">{{'successComp.withdrawSuccessTitle' | translate}}</h5>
            <p class="h-modal__success--desc">{{'successComp.withdrawSuccessMsg' | translate}}</p>
        </div>
      </div>
       <!-- Cancel Withdraw wrapper -->
       <div class="h-modal__success clearfix" *ngIf="cancelledPendingWithdrawAmount">
        <div class="h-modal__success--left-blk">
          <span class="h-modal__success--icon icon-checkbox"></span>
        </div>
        <div class="h-modal__success--right-blk">
          <h5 class="h-modal__success--title">{{'cashier.cancelwithdrawalsuccesssfullmessage' | translate}}</h5>
          <p class="h-modal__success--desc">{{'cashier.cancelwithdrawalsuccesssfulldescpart1' | translate}} {{cancelledPendingWithdrawAmount}} {{'cashier.cancelwithdrawalsuccesssfulldescpart2' | translate}}</p>
        </div>
      </div>
      <div class="h-modal__body pending_withdraw__body--inner">
       

          <div class="pending_withdraw">

            <!-- Pending Withdrawal data -->
            <ng-container *ngIf="isPendingWithDrawsAvailable">
              
              <ng-container *ngIf="pendingWithdrawals.length>0">
                <div class="pending_withdraw--items" >
                  <div class="pending_withdraw--item clearfix"
                  *ngFor="let withdrawal of pendingWithdrawals;let i=index">
                    <div class="pending_withdraw--body">
                      <div class="pending_withdraw--body-left" *ngIf = "!userDetailsService.checkIsPNPUser()">
                        <div class="pending_withdraw--amount">
                          <!-- {{userDetailsService.getUserCurrencySymbol()}}{{item.initialAmount | number:'1.2-2'}}--> 
                          {{amountCurrencyFormat(withdrawal.amount)}}
                        </div>
                        <div class="pending_withdraw--subtitle">{{'cashier.cancelPendingrequest' | translate}}</div>
                        <div class="pending_withdraw--date">
                          <!-- {{item.createdTime*1000 | date:'medium'}} -->
                          {{withdrawal.created | date:'medium'}}
                        </div>
                      </div>
                      <div class="pending_withdraw--body-left" *ngIf = "userDetailsService.checkIsPNPUser()">
                        <div class="pending_withdraw--amount">
                          {{withdrawal.initialAmount | currencyPipe}} 
                        </div>
                        <div class="pending_withdraw--subtitle">{{'cashier.cancelPendingrequest' | translate}}</div>
                        <div class="pending_withdraw--date">
                          {{withdrawal.createdTime*1000 | date:'medium'}}
                        </div>
                      </div>
                      <div class="pending_withdraw--body-right">
                        <span class="pending_withdraw--status">{{withdrawStatus}}</span>
                      </div>
                    </div>
                    <div class="pending_withdraw--footer flex_verticalalign" *ngIf = "!userDetailsService.checkIsPNPUser()">
                      <button href="javascript:void(0)" id="delete_withdrawal--cta-{{i}}"
                        class="site-btn pending_withdraw--cancelBtn tertiary_loader loader_small"
                        (click)="deleteWithdrawal(withdrawal.transactionId,withdrawal.amount,'delete_withdrawal--cta-' + i)"><span>{{'cashier.cancel' | translate}}</span></button>
                    </div>
                    <div class="pending_withdraw--footer flex_verticalalign" *ngIf = "userDetailsService.checkIsPNPUser()">
                      <button href="javascript:void(0)" id="delete_withdrawal--cta-{{i}}"
                        class="site-btn pending_withdraw--cancelBtn tertiary_loader loader_small"
                        (click)="deleteZimplerPendingAmount(withdrawal.txnId,withdrawal.amountInEcrCurrency,'delete_withdrawal--cta-' + i)"><span>{{'cashier.cancel' | translate}}</span></button>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container *ngIf="isPendingWithDrawsAvailable && pendingWithdrawals.length === 0" >
                <div class="pending_withdraw--items no-pending_withdrawals">
                  <div class="pending_withdraw--body">
                    {{'cashier.nopendingwithdrawal' | translate}}
                  </div>
                </div>
              </ng-container>
            </ng-container>

            <!-- Skelton loader view -->
            <div class="pending_withdraw--items" *ngIf="!isPendingWithDrawsAvailable">
              <div class="pending_withdraw--item clearfix" *ngFor="let item of [].constructor(3)">
                <div class="pending_withdraw--body">
                  <div class="pending_withdraw--body-left">
                    <div class="pending_withdraw--amount  animated-background"></div>
                    <div class="pending_withdraw--subtitle  animated-background"></div>
                    <div class="pending_withdraw--date  animated-background"></div>
                  </div>
                  <div class="pending_withdraw--body-right">
                    <span class="pending_withdraw--status  animated-background"></span>
                  </div>
                </div>
                <div class="pending_withdraw--footer flex_verticalalign">
                  <a href="javascript:void(0)" class="pending_withdraw--cancelBtn  animated-background"></a>
                </div>
              </div>
            </div>
          </div>

      </div>
    </div>

    <!-- Hamburger Modal Footer -->
    <!-- <div class="h-modal__footer flex_verticalalign flex_justifyCenter">
      <button class="prefer_btn site-btn site-btn__primary site-btn--lg"
      (click)="close()">{{'failureComp.closeBtn' | translate}}</button>
    </div> -->


  </div>
</modal>